import React, { useContext, useEffect, useRef, useState } from 'react'
import QuestionComponent from './QuestionComponent';
import OptionsComponent from './OptionsComponent';
import { firestore } from '../../../../firebase.config';
import { DataContext } from '../../../../Context/DataContext';

import CLIO from '../../../../assets/icons/clio.png';
import DOCKET from '../../../../assets/icons/dock-wise.png';
import LOLLYLAW from '../../../../assets/icons/lollylaw.png';
import INSZOOM from '../../../../assets/icons/ins-zoom.png';
import EIIMG from '../../../../assets/icons/ei-immigration.png';
import LAWLOGIX from '../../../../assets/icons/lawlogix.png';
import PRIMA from '../../../../assets/icons/prima.png';
import { useScreenTransition } from '../../../../Hooks/useScreenTransition';

const platforms = [
    {
    value: "Clio",
    icon: CLIO,
    },
    {
        value: "Docketwise",
      icon: DOCKET,
    },
    {
        value: "INSZoom",
      icon: INSZOOM,
    },
    {
        value: "LollyLaw",
    icon: LOLLYLAW,
    },
    {
        value: "LawLogix",
      icon: LAWLOGIX,
    },
    {
        value: "Prima",
      icon: PRIMA,
    },
    {
      value: "EImmigration by Cerenade",
    icon: EIIMG,
    },
    {
        value: "We don’t use any platform",
      icon: null,
    },
    {
        value: "Other",
      icon: null,
    }
  ]

const question =  {
  title: "2. Legal Platforms",
  question: "Which platforms does your team use for case or client management?",
  options: platforms,
}

const Ques2 = ({windowSize, currentScreen, setCurrentScreen, onContinue}) => {
    const [selectedOption, setSelectedOption] = useState([]);
    const {userData, teamData} = useContext(DataContext);
    const [otherInput, setOtherInput] = useState("");

    const { transitionTo } = useScreenTransition();

    const otherInputRef = useRef(null);

    useEffect(() => {
      if(userData && userData.teamId && teamData){
        const onBoarding = teamData.onBoarding;
        if(!onBoarding || !onBoarding.translation_workflow){
          transitionTo(`/account/onboarding?step=1`);
          return;
        }
        if(onBoarding && onBoarding.immigration_platforms){
          setSelectedOption(onBoarding.immigration_platforms);
          onBoarding.immigration_other_platform && setOtherInput(onBoarding.immigration_other_platform);
        }
      }
    }, [userData, teamData])

    const onContinueQuestion = () => {
      const onBoarding = teamData.onBoarding;
      firestore.collection("teams").doc(userData.teamId).update(
        {
          onBoarding: onBoarding ? {...onBoarding, immigration_platforms: selectedOption, immigration_other_platform: otherInput} 
          : {immigration_platforms: selectedOption, immigration_other_platform: otherInput}
        }).then(() => {
          onContinue();
        })
    }

    const onClickOption = (option) => {
      if(option.value === platforms[7].value){
        setSelectedOption([option.value]);
        return;
      }
      if(selectedOption.includes(option.value)){
        setSelectedOption(selectedOption.filter(o => o !== option.value));
        if(option.value === platforms[8].value){
          setOtherInput("");
        }
      } else {
        setSelectedOption([...selectedOption.filter(o => o !== platforms[7].value), option.value]);
        if(option.value === platforms[8].value){
          setOtherInput("");
        }
      }
    otherInputRef.current && otherInputRef.current.focus();

    }

    const checkSelected = (option) => {
      if(Array.isArray(selectedOption)){
        return selectedOption.includes(option.value);
      }
      return selectedOption === option.value;
    }

  return (
    <QuestionComponent
    windowSize={windowSize}
    question={question.question}
    onContinue={onContinueQuestion}
    progressTitle={question.title}
    progress={1}
    onBack={() => transitionTo(`/account/onboarding?step=${currentScreen - 1}`)}
    backBTnText="Back"
    disableContinue={!teamData || selectedOption.length === 0 || (selectedOption.includes(platforms[8].value) && otherInput === "")}
    // showInput={selectedOption.includes("Other")}
    // inputValue={otherInput}
    // setInputValue={setOtherInput}
  >
    <div className={`flex gap-[8px] w-full flex-wrap max-sm:flex-col`}>
      {question.options.map((option, index) => 
        <div key={index} className={`relative flex justify-start items-center gap-2 min-w-[200px] overflow-hidden
          bg-[#fff] rounded-[8px] ${option.value === platforms[8].value && selectedOption.includes(platforms[8].value)  ? "px-[16px] pt-[16px] pb-[8px]" : "px-[16px] py-[16px]"} cursor-pointer hover:border-[#12ABBF]  min-h-[54px]
          ${checkSelected(option) ? 'border-[#12ABBF] border-[2px]' : 'border-[#E6E7E9] border-[1px]'} "w-max" max-sm:w-full`} onClick={() => onClickOption(option)}>
             {option.icon && <img src={option.icon} alt={""} className='w-[24px] h-[24px]'/> }
             <p className={`${option.value === platforms[8].value ? `transition-all duration-300 absolute text-[#686f7b] ${selectedOption.includes(platforms[8].value) ? "text-[12px] weight-[400] top-[4px] left-[8px]" : "top-[18px] left-[16px] onBoarding-description"}` : "onBoarding-description"}`}>
              {option.value}
              </p> 
              {option.value === platforms[8].value && selectedOption.includes(platforms[8].value) && 
              <input ref={otherInputRef} type="text" autoFocus className='min-w-[160px] w-full h-[18px] border-[0] outline-none bg-transparent text-[14px] weight-[400]' placeholder='Specify the platform' value={otherInput} onChange={(e) => setOtherInput(e.target.value)} onClick={(e) => e.stopPropagation()}/>
              }
        </div>
      )}
    </div>

  </QuestionComponent>
  )
}

export default Ques2;